import { render, staticRenderFns } from "./SidebarRankingCard.vue?vue&type=template&id=12e252cc&scoped=true"
import script from "./SidebarRankingCard.vue?vue&type=script&lang=js"
export * from "./SidebarRankingCard.vue?vue&type=script&lang=js"
import style0 from "./SidebarRankingCard.vue?vue&type=style&index=0&id=12e252cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e252cc",
  null
  
)

export default component.exports